import React from 'react'
import { Popup, Icon } from 'semantic-ui-react'

export default class Tooltip extends React.Component {
  render() {
    const { trigger, content, infoIcon, infoIconColor, style, position } = this.props

    return (
      <Popup
        style={style}
        position={position}
        trigger={
          <div>
            {infoIcon &&
              <Icon
                name='info circle'
                color={infoIconColor || 'black'}
                style={{paddingRight: "5px"}}
              />
            }
            {trigger}
          </div>
        }
        content={content}
        on='click'
      />
    )
  }
}
